<template>
  <button
    :style="buttonStyle"
    class="gradient-btn inline-flex items-center justify-center rounded-xl px-6 text-white transition hover:brightness-105 active:scale-[0.98]"
    @click="onClick"
  >
    {{ text }}
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue";

type Props = {
  text: string;
  width?: string;
  height?: string;
  onClick?: () => void;
};

const props = withDefaults(defineProps<Props>(), {
  width: "auto",
  height: "40px",
  onClick: () => {},
});

const buttonStyle = computed(() => ({
  width: props.width,
  height: props.height,
}));
</script>

<style scoped>
.gradient-btn {
  font-family:
    "M PLUS Rounded 1c",
    system-ui,
    -apple-system,
    sans-serif;

  font-size: 13px;
  /* 👈 smaller to match image */
  line-height: 1;
  /* keeps it vertically centered */
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;

  background: linear-gradient(90deg, #4b2d83 0%, #7b1fa2 50%, #ec1379 100%);

  box-shadow: 0 3px 10px rgba(44, 18, 71, 0.18);
}
</style>
